module.exports = __webpack_public_path__ + "img/count_plus.913a2623.svg";